import { ComponentType } from 'react';

import { OrderAheadConfigurationNavbarIcon } from '@ocx/graphql';

import { orderAheadTabIconMap } from './order-ahead.constants';

export const getOrderAheadTabIcon = (icon: OrderAheadConfigurationNavbarIcon): ComponentType => {
  return orderAheadTabIconMap[icon];
};
